import { getContrast, darken } from 'polished';

export const darkenColorUntilHasContrastEnough = (
  bgColor: string,
  color: string,
  run = 0,
) => {
  const contrast = getContrast(bgColor, color);
  if (run > 10) return color;
  if (contrast < 3) {
    return darkenColorUntilHasContrastEnough(
      bgColor,
      darken(0.1, color),
      run + 1,
    );
  }
  return color;
};
